export const COLUMN_VISIBILITY_STORAGE_KEY = 'scout-table-column-visibility'
